/**
 * The api should follow backend api's rule
 * Example: /exchange-api/v1/private/mbxgateway/[user-stream]/start
 * We name the action like user-stream, the end path of api
 * actionName: userStream, and group apis & action types
 *
 * If the parent's api is name like a service,
 * Example: /exchange-api/v1/public/[asset-service]/product/get-products
 * We name the it as a service assetService
 */

const GATE_WAY = 'gateway-api';
const GATE_WAY_HOST = process.env.ALT_GATE_WAY || '/gateway-api';

export default {
  // Asset service apis
  USER_TRADE_FEE_API_PATH: '/exchange-api/v1/public/asset-service/product/get-trade-fee',
  CURRENCY_RATE_API_PATH: '/exchange-api/v1/public/asset-service/product/currency',
  PRODUCTS_API_PATH: '/exchange-api/v1/public/asset-service/product/get-products',
  GET_USER_ASSET_API: '/exchange-api/v2/private/asset-service/asset/get-user-asset',
  GET_USER_BTC_VALUATION_API: '/exchange-api/v1/private/asset-service/asset/btc-valuation',
  FAVORITES_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/get',
  DELETE_FAVORITE_DATA_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/del',
  ADD_FAVORITE_DATA_API_PATH: '/exchange-api/v1/private/asset-service/portfolio/add',
  FETCH_WITHDRAW_LIMIT_API_PATH: '/assetWithdraw/getWithdrawNum.html',
  APPLY_WITHDRAW_API_PATH: '/assetWithdraw/applyWithdraw.html',
  WITHERAW_RESEND_EMAIL_API_PATH: '/gateway-api/v1/private/capital/withdraw/reSendMail',
  WITHERAW_CANCEL_API_PATH: '/gateway-api/v1/private/capital/withdraw/cancel',
  ASSET_PRICE_CONVERT:
    '/gateway-api/v1/public/asset-service/product/price-convert?amount=1&from=BTC&to=USDT',

  // User stream apis
  START_STREAM_API_PATH: '/exchange-api/v1/private/mbxgateway/user-stream/start',
  USER_STREAM_PING_API: '/exchange-api/v1/private/mbxgateway/user-stream/ping',

  // Mbxgateway order apis
  ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/place',
  DELETE_ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/del',
  DELETE_ALL_ORDER_API_PATH: '/exchange-api/v1/private/mbxgateway/order/delall',
  OCO_ORDER_API_PATH: `/${GATE_WAY}/v1/private/mbxgateway/order/oco/place`,
  OPEN_ORDERS_API_PATH: '/exchange-api/v1/private/streamer/order/get-open-orders',
  TRADE_ORDERS_API_PATH: '/exchange-api/v1/private/streamer/order/get-trade-orders',
  USER_TRADES_API_PATH: '/exchange-api/v1/private/streamer/trade/get-user-trades',
  USER_TRADE_DETAIL_API_PATH: '/exchange-api/v1/private/streamer/trade/get-user-trade-detail',

  // Account apis
  USER_INFO_API_PATH: '/gateway-api/v1/private/account/user/base-detail',
  GET_KYC_VALIDATE_INFO_API: '/gateway-api/v1/private/account/user-kyc/get-kyc-validate-info',
  GET_CURRENT_KYC_VALIDATE_INFO_API: '/gateway-api/v1/private/account/user-kyc/current-kyc-status',
  USER_LOGS_API_PATH: '/gateway-api/v1/private/account/user/get-user-login-log',
  GET_USER_CONFIG_API: '/gateway-api/v1/private/account/user-config/get',
  GET_AGENT_ID_INFO: `${GATE_WAY_HOST}/v1/public/account/agent-info/get`,
  REGISTER_API_PATH: `${GATE_WAY_HOST}/v1/public/account/user/register`,
  RESEND_EMAIL_API_PATH: `${GATE_WAY_HOST}/v1/public/account/user/resend-register-email`,
  SEND_MOBILE_VERIFY_CODE_API: '/gateway-api/v1/protect/account/mobile/send-mobile-verify-code',
  BIND_MOBILE_API: '/gateway-api/v1/private/account/user/bind-mobile',
  SEND_BIND_MOBILE_VERIFY_CODE: '/gateway-api/v1/private/account/user/send-bind-mobile-verify-code',
  BIND_GOOGLE_VERIFY_API: '/gateway-api/v1/private/account/user/bind-google-verify',
  UNBIND_GOOGLE_VERIFY_API: '/gateway-api/v1/private/account/user/unbind-google-verify',
  UNBIND_MOBILE_API: '/gateway-api/v1/private/account/user/unbind-mobile',
  GENERATE_SECRET_KEY_API: '/gateway-api/v1/private/account/user/generate-secret-key',
  GET_COUNTRY_SHORT_NAME: '/gateway-api/v1/public/account/ip/country-short',
  USER_AGENT_MESSAGE: '/gateway-api/v1/public/account/user/agent-rate/get',
  OPEN_WITHDRAW_WHITE_STATUS_API_PATH:
    '/gateway-api/v1/private/account/user/open-withdraw-white-status',
  CLOSE_WITHDRAW_WHITE_STATUS_API_PATH:
    '/gateway-api/v1/private/account/user/close-withdraw-white-status',
  SAVE_USER_CONFIG_API_PATH: '/gateway-api/v1/private/account/user-config/save',
  ANTI_PHISHING_CODE_API_PATH: '/gateway-api/v1/private/account/user/get-anti-phishing-code',
  SET_ANTI_PHISHING_CODE_API_PATH: '/gateway-api/v1/private/account/user/set-anti-phishing-code',
  SEND_SMS_CODE_API_PATH: '/gateway-api/v1/protect/account/mobile/send-mobile-verify-code',
  SET_COMMISSION_STATUS_API_PATH: '/gateway-api/v1/private/account/user/set-commission-status',
  TRADE_LEVEL_API_PATH: `${GATE_WAY_HOST}/v1/public/account/trade-level/get`,
  TRADE_INFO_API_PATH: '/gateway-api/v1/private/account/trade-info/get',
  // USER_TOTAL_COMMISSION_API_PATH: '/gateway-api/v1/private/account/commission/total',
  USER_DEVICE_LIST_API_PATH: '/gateway-api/v1/private/account/user-device/page',
  DELETE_USER_DEVICE_API_PATH: '/gateway-api/v1/private/account/user-device/delete',
  FETCH_USER_DEVICE_LOG_API_PATH: '/gateway-api/v1/private/account/user-device/log/page',
  USER_UPDATE_PASSWORD_API: '/gateway-api/v1/private/account/user/update-password',
  FETCH_ACCOUNT_ACTIVITY_RECORD:
    '/gateway-api/v1/private/account/user-operation-log/last-7-days/query',
  DISABLE_ACCOUNT: '/gateway-api/v1/private/account/user/forbidden-by-oneself',
  CHECK_ACCOUNT_WITHDRAW_FACE_STATUS: '/gateway-api/v1/private/account/user/check/withdraw-face',
  CHECK_ACCOUNT_WITHDRAW_HISTORY_ADDRESS_STATUS:
    '/gateway-api/v1/private/account/user/check/withdraw-historyAddr',
  UPDATA_USER_BASE_INFO: '/gateway-api/v1/private/account/user-kyc/submit-base-info',
  FACE_INIT_API_PATH: `${GATE_WAY_HOST}/v1/public/account/user-face/sdk-face-init`,
  WEB_FACE_INIT_API_PATH: `${GATE_WAY_HOST}/v1/public/account/user-face/web-face-init`,
  UPDATA_COMPANY_BASE_INFO:
    '/gateway-api/v1/private/account/user-certificate/submit-company-certificate',
  UPDATA_FACE_VERIFY_STATUS: `${GATE_WAY_HOST}/v1/public/account/user-face/face-is-passed`,
  GET_COUNTRY_IP_RESTRICTED: `${GATE_WAY_HOST}/v1/public/country/ip/restricted`,

  // Common apis
  ACQUIRE_HOLD_BNB_API: `${GATE_WAY_HOST}/v1/public/common/config/bnb`,
  URL_AND_PROJECT_API: `${GATE_WAY_HOST}/v1/public/common/config/url-and-project`,
  USER_GAS_RATE_API_PATH: `${GATE_WAY_HOST}/v1/public/common/config/get-by-name`,
  GET_GEETEST_CODE_API_PATH: `${GATE_WAY_HOST}/v1/public/common/security/gt-code`,
  REF_SWITCH_API_PATH: `${GATE_WAY_HOST}/v1/public/common/config/get-ref-switch`,
  GET_REGISTER_OPEN_STATUS: `${GATE_WAY_HOST}/v1/public/common/config/register-open-status`,

  // Fiat payment apis
  GET_BANK_INFO_API: '/gateway-api/v1/private/fiatpayment/get-bank-info',
  APPLY_CHARGE_API_PATH: '/gateway-api/v1/private/fiatpayment/apply-charge',
  QUERY_BALANCE_API_PATH: '/gateway-api/v1/private/fiatpayment/query-balance',
  APPLY_WITHDRWA: '/gateway-api/v1/private/fiatpayment/apply-withdraw',
  BIND_CONFIRM_API_PATH: '/gateway-api/v1/private/fiatpayment/bind-confirm',
  BIND_SEND_OPT_API_PATH: '/gateway-api/v1/private/fiatpayment/bind-send-opt',
  GET_CHARGE_ADDRESS: '/gateway-api/v1/private/fiatpayment/get-charge-address',
  CHARGE_WITHDRAW_HISTORY: '/gateway-api/v1/private/fiatpayment/charge-withdraw-histroy',

  // Authcenter apis
  USER_VERIFY_TOKEN: `${GATE_WAY_HOST}/v1/public/authcenter/auth`,
  USER_LOGIN_OUT_API: '/gateway-api/v1/private/authcenter/logout',
  LOGIN_API_PATH: `${GATE_WAY_HOST}/v1/public/authcenter/login`,
  CONFIRM_TIP: '/gateway-api/v1/private/account/user/confirm-tip',
  FORGET_PASSWORD_SEND_EMAIL: `${GATE_WAY_HOST}/v1/public/account/user/forgot-password`,
  RESET_PASSWORD: `${GATE_WAY_HOST}/v1/public/account/user/reset-password`,
  GET_LOGIN_QR_CODE: `${GATE_WAY_HOST}/v1/public/qrcode/get`,
  GET_LOGIN_QR_CODE_TITLE: `${GATE_WAY_HOST}/v1/public/qrcode/config/qrcode.webtip`,
  QUERY_LOGIN_QR_CODE: `${GATE_WAY_HOST}/v1/public/qrcode/query`,

  // User device apis
  DELETE_DEVICE_HISTORY: '/gateway-api/v1/private/account/user-device/delete',
  USER_DEVICES_LIST_API_PATH: '/gateway-api/v1/private/account/user-device/list',
  DEVICE_HISTORY: '/gateway-api/v1/private/account/user-device/log',

  // Asset apis
  GET_SYMBOL_BY_ASSET_API_PATH: `${GATE_WAY_HOST}/v1/public/asset/symbols/get`,
  USER_DIVIDENDS_API_PATH: '/gateway-api/v1/private/asset/asset/user-asset-dividend',
  GET_ASSET_INTO_API_PATH: `${GATE_WAY_HOST}/v1/public/asset/asset/get`,
  GET_ALL_ASSETS_API_PATH: `${GATE_WAY_HOST}/v1/public/asset/asset/get-all-asset`,
  GET_ALL_ASSETLOGO_API_PATH: `${GATE_WAY_HOST}/v1/public/asset/asset/get-asset-logo`,
  GET_WITHDRAW_ADDRESS_LIST:
    '/gateway-api/v1/private/asset/withdraw-address/get-withdraw-address-list',
  DELETE_WITHDRAW_ADDRESS: '/gateway-api/v1/private/asset/withdraw-address/delete-withdraw-address',
  SAVE_WITHDRAW_ADDRESS_API_PATH:
    '/gateway-api/v1/private/asset/withdraw-address/save-withdraw-address',
  ADD_TO_WHITELIST_API_PATH: '/gateway-api/v1/private/asset/withdraw-address/update-white-status',
  REMOVE_FROM_WHITELIST_API_PATH:
    '/gateway-api/v1/private/asset/withdraw-address/delete-white-withdraw-address',

  // market apis
  GET_NOTICE_API_PATH: `${GATE_WAY_HOST}/v1/public/market/notice/get`,
  GET_RECOMMEND_API_PATH: `${GATE_WAY_HOST}/v1/public/market/recommend/get-info`,
  RECOMMENDS_API_PATH: `${GATE_WAY_HOST}/v1/public/market/recommend/get-asset`,

  // notification apis
  GET_ABNORMAL_TRADE_NOTICE_LIST: `${GATE_WAY_HOST}/v1/public/notification/trade-notice/get-abnormal-trade-notice-list`,

  // dex testnet
  DEX_TESTNET_GET_ADDRESS: '/gateway-api/v1/private/dex-campaign/user-addresses',
  DEX_TESTNET_ADD_ADDRESS: '/gateway-api/v1/private/dex-campaign/add-addresses',
  DEX_USER_TRADING_INFO: '/gateway-api/v1/private/dex-campaign/user-campaign-account',
  DEX_TOP_YIELD_ACCOUNTS: `${GATE_WAY_HOST}/v1/public/dex-campaign/top-yield-accounts`,
  DEX_TOP_VOLUME_ACCOUNTS: `${GATE_WAY_HOST}/v1/public/dex-campaign/top-volume-accounts`,
  DEX_TOP_CAMPAIGN_ASSETS: `${GATE_WAY_HOST}/v1/public/dex-campaign/campaign-assets`,

  // Country apis
  CHECK_IP_API_PATH: `${GATE_WAY_HOST}/v1/public/country/support/check/ip`,
  GET_COUNTRY_WHITELIST: `${GATE_WAY_HOST}/v1/public/country/list`,

  // Simplex apis
  GET_SIMPLEX_QUORE: `${GATE_WAY_HOST}/v1/public/simplex/get-quote`,
  GET_SIMPLEX_CURRENCY_LIST: `${GATE_WAY_HOST}/v1/public/simplex/get-currency-list`,
  SEND_PAYMENT_REQUEST: '/gateway-api/v1/private/simplex/send-payment-request',
  CHECK_SIMPLEX_STATUS: `${GATE_WAY_HOST}/v1/public/simplex/get-status`,
  CHECK_WHITE_LIST_USER: '/gateway-api/v1/private/country/support/check/userId',

  // blog
  BLOG_LIST_API: `${GATE_WAY_HOST}/v1/public/article/list/page`,
  BLOG_DETAIL_API: `${GATE_WAY_HOST}/v1/public/article/detail/get`,
  BLOG_DETAIL_LOCALES_API: `${GATE_WAY_HOST}/v1/public/article/language/support`,

  // Api create apis
  GET_ALL_API: '/gateway-api/v1/private/api-mgmt/api/all',
  DEL_API: '/gateway-api/v1/private/api-mgmt/api/del',
  DEL_ALL_API: '/gateway-api/v1/private/api-mgmt/api/delall',
  SAVE_API: '/gateway-api/v1/private/api-mgmt/api/save',
  UPDATE_API: '/gateway-api/v1/private/api-mgmt/api/update',
  ENABLE_CREATE_API: `${GATE_WAY_HOST}/v1/public/api-mgmt/api/enable-api-create`,
  ENABLE_WITHDRAW: `${GATE_WAY_HOST}/v1/public/api-mgmt/api/enable-api-withdraw`,

  // Info apis
  ASSET_INFO_API: '/info-api/v1/public/get-info',

  // Margin apis
  MARGIN_ACCOUNT_ENABLE: `/${GATE_WAY}/v1/private/account/user/createMarginAccount`,
  MARGIN_ACCOUNT_DETAIL: `/${GATE_WAY}/v1/private/margin/account-details`,
  MARGIN_COEFF: `${GATE_WAY_HOST}/v1/friendly/margin/coeff`,
  MARGIN_SYMBOLS: `${GATE_WAY_HOST}/v1/public/margin/symbols`,
  MARGIN_TRANSFER_IN: `/${GATE_WAY}/v1/private/margin/transfer-in`,
  MARGIN_TRANSFER_OUT: `/${GATE_WAY}/v1/private/margin/transfer-out`,
  MARGIN_TRANSFER_OUT_AMOUT: `/${GATE_WAY}/v1/private/margin/max-transferable`,
  MARGIN_ALL_ASSET: `${GATE_WAY_HOST}/v1/public/margin/asset/all`,
  MARGIN_BORROW_AMOUT: `/${GATE_WAY}/v1/private/margin/max-borrowable`,
  MARGIN_BORROW: `/${GATE_WAY}/v1/private/margin/borrow`,
  MARGIN_REPAY: `/${GATE_WAY}/v1/private/margin/repay`,
  MARGIN_BORROW_HISTORY: `/${GATE_WAY}/v1/private/margin/borrow-history`,
  MARGIN_REPAY_HISTORY: `/${GATE_WAY}/v1/private/margin/repay-history`,
  MARGIN_TRANSFER_HISTORY: `/${GATE_WAY}/v1/private/margin/transfer-history`,
  MARGIN_INTEREST_HISTORY: `/${GATE_WAY}/v1/private/margin/interest-history`,
  MARGIN_CALL_HISTORY: `/${GATE_WAY}/v1/private/margin/notification-histories`,
  MARGIN_INTEREST_HISTORY_LIST: `/${GATE_WAY}/v1/private/interest-history/list`,
  MARGIN_ORDER_PLACE: `/${GATE_WAY}/v1/private/margin/place-order`,
  MARGIN_ORDER_PLACE_ASSET: `/${GATE_WAY}/v1/private/margin/margin-buy`, // deprecated
  MARGIN_ORDER_PLACE_ASSET_BORROWABLE: `/${GATE_WAY}/v1/private/margin/margin-buy/borrowable`, // margin buy market borrow amount
  MARGIN_ORDER_DELETE_ORDER: `/${GATE_WAY}/v1/private/margin/cancel-order`,
  MARGIN_ORDER_DELETE_ALL: `/${GATE_WAY}/v1/private/margin/cancel-all-order`,
  MARGIN_PRICE_INDEX_HISTORY: `${GATE_WAY_HOST}/v1/public/margin/price-index/history`,
  MARGIN_ALL_PRICE_INDEX: `${GATE_WAY_HOST}/v1/public/margin/all-price-index`,
  MARGIN_INTEREST_RATE: `/${GATE_WAY}/v1/friendly/margin/interest-rate`,
  MARGIN_VIP_INTEREST_RATE: `${GATE_WAY_HOST}/v1/public/margin/vip/spec/list-all`,
  MARGIN_VIP_INTEREST_RATE_ADJ: `${GATE_WAY_HOST}/v1/public/margin/vip/spec/interest-rate-adj`,
  MARGIN_VALIDATE_BAR: `/${GATE_WAY}/v1/private/margin/validate-before-adjust-margin-bar`,
  MARGIN_ADJUST_BAR: `/${GATE_WAY}/v1/private/margin/adjust-margin-bar`,
  MARGIN_FEE_MAX_BORROW: `/${GATE_WAY}/v1/private/margin/max-borrow`,

  // Referral apis
  COMMISSION_TOTAL_PATH: `/${GATE_WAY}/v1/private/account/commission/total`,
  COMMISSION_DETAIL_PATH: `/${GATE_WAY}/v1/private/account/commission/detail`,
  COMMISSION_TOP_PATH: `${GATE_WAY_HOST}/v1/public/account/commission/top`,
  AGENT_DOWNLOAD_PATH: `/${GATE_WAY}/v1/private/account/agent/download`,
  COMMISSION_DOWNLOAD_PATH: `/${GATE_WAY}/v1/private/account/commission/download`,

  // coin apply
  COIN_APPLY_PATH: '/gateway-api/v1/private/market/asset/apply',

  // Small crypto to BNB
  DRIBBLET_BTC_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-btc',
  DRIBBLET_BNB_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-bnb',
  DRIBBLET_LOG_PATH: '/exchange-api/v1/private/asset-service/asset/dribblet-log',

  GATEWAY_CHANNEL: `${GATE_WAY_HOST}/v1/public/common/config/fiat-gateway-channel`,

  // Reset2fa
  PRE_VALIDATE: `/${GATE_WAY}/v1/protect/account-reset2fa/pre-validated`,
  FLOW_NEXT_STEP: `/${GATE_WAY}/v1/protect/account-reset2fa/flow-next-step`,
  GET_QUESTIONS: `/${GATE_WAY}/v1/protect/account-reset2fa/get-question`,
  ANSWER_QUESTION: `/${GATE_WAY}/v1/protect/account-reset2fa/answer-question`,
  FLOW_OPEN_EMAIL: `/${GATE_WAY}/v1/protect/account-reset2fa/flow-open-email`,
  RESEND_EMAIL_FOR_RESET: `/${GATE_WAY}/v1/protect/account-reset2fa/resend-email`,

  // Support Center
  INSTANT_SEARCH_API: `${GATE_WAY_HOST}/v1/public/zendesk/instant-search`,

  // promoCode
  GET_HAS_TRADE_AMOUNT: '/gateway-api/v1/private/report/reward/marketing/get',
  GET_PROMOCODE_API: '/gateway-api/v1/private/issue-reward/event/issue-record/list',
  GET_PROMOCODE_EVENT_INFO: '/gateway-api/v1/private/issue-reward/event/rule/list',
  FETCH_PROMOCODE_API: '/gateway-api/v1/private/issue-reward/event/rule/stock/fetch',

  // webauthn apis
  WEBAUTHN_START_REGISTER: `/${GATE_WAY}/v1/private/account/web-authn/register/start`,
  WEBAUTHN_FINISH_REGISTER: `/${GATE_WAY}/v1/private/account/web-authn/register/finish`,
  WEBAUTHN_START_AUTHENTICATE: `${GATE_WAY_HOST}/v1/public/account/web-authn/authenticate/start`,
  WEBAUTHN_FINISH_DEREGISTER: `/${GATE_WAY}/v1/private/account/web-authn/deregister`,
  WEBAUTHN_QUERY: `/${GATE_WAY}/v1/private/account/web-authn/query`,
  WEBAUTHN_ORIGIN_SUPPORTED: `${GATE_WAY_HOST}/v1/public/account/web-authn/origin-supported`,
  WEBAUTHN_SECURITY_KEY_UPDATE: `/${GATE_WAY}/v1/private/account/user/security-key/scenario/update`,

  // Change Email Address
  USER_EMAIL_INIT_API: `/${GATE_WAY}/v1/private/account/user/email/init`,
  USER_EMAIL_CONFIRM: `/${GATE_WAY}/v1/private/account/user/email/confirm`,

  // get asset min trade
  USER_MIN_TRADE_INFO_PAI_PATH: `/${GATE_WAY}/v1/public/asset-service/product/get-exchange-info`,
  // answer question
  GET_QUESTION_CONFIG: `${GATE_WAY_HOST}/v1/public/account-question-module/get-question-config`,
  GET_QUESTION: `/${GATE_WAY}/v1/public/account-question-module/get-question`,
  ANSWER_ONE_QUESTION: `${GATE_WAY_HOST}/v1/public/account-question-module/answer-one-question`,

  // inmail data api
  GET_IN_MAIL_DATA_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/select`,
  GET_IN_MAIL_MODULS_API_PATH: `/${GATE_WAY}/v1/private/inbox/module/all/select`,
  SET_IN_MAIL_READ_DELET_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/read_delete`,
  SET_IN_MAIL_UNREAD_API_PATH: `/${GATE_WAY}/v1/private/inbox/message-text/count/unread`,
  GET_IN_MAIL_STREAM_TOKEN_API_PATH: `/${GATE_WAY}/v1/private/inbox/user/token/get`,

  // JPush
  JPUSH_SET_ALIAS_AND_TAGS: '/gateway-api/v1/public/notification/device/set-alias-and-tags',
  JPUSH_WEB_SDK_INIT: '/gateway-api/v1/public/notification/device/web-sdk-init-params',

  // Staking
  STAKING_LIST: `/${GATE_WAY}/v1/friendly/staking/list`,
  STAKING_DETAIL: `/${GATE_WAY}/v1/friendly/staking/detail`,
  STAKING_REBATE: `/${GATE_WAY}/v1/private/staking/rebate`,
  STAKING_HOLD_HISTORY: `/${GATE_WAY}/v1/private/staking/userSnapshot`,
  // capital
  GET_NETWORK_COIN_ALL: `/${GATE_WAY}/v1/public/capital/getNetworkCoinAll`,
  // Vote2
  VOTE2_PROJECT: `/${GATE_WAY}/v1/public/marketing/vote2/project`,
  VOTE2_PROJECT2: `/${GATE_WAY}/v1/private/marketing/vote2/project`,
  VOTE2_LOG_VOTE: `/${GATE_WAY}/v1/private/marketing/vote2/log-vote`,
  VOTE2_PROFIT: `/${GATE_WAY}/v1/private/marketing/vote2/profit`,
  VOTE2_VOTE: `/${GATE_WAY}/v1/private/marketing/vote2/vote`,
  VOTE2_LOG_BNB: `/${GATE_WAY}/v1/private/marketing/vote2/log-bnb`,
  // Official verification channel
  VERIFICATION_RESULT: `/${GATE_WAY}/v1/public/official-channel/verify`,

  GET_FORBIDEN_EMAIL_API_PATH: `/${GATE_WAY}/v1/public/account/email/forbidenconfig`,

  // Share
  FETCH_SHARE_CONFIG: `/${GATE_WAY}/v1/private/snapshot/uploadurl/get`,
  FETCH_QRCODE_DOMAIN: `/${GATE_WAY}/v1/private/account/commission/qrcode/domain`,

  // confirm new device
  DEVICE_RESEND_EMAIL_API_PATH: `/${GATE_WAY}/v1/protect/account/user-device/resendAuthorizeDeviceEmail`,
  DEVICE_AUTH_FOR_NEW_PROCESS: `/${GATE_WAY}/v1/protect/account/user-device/authorizeForNewProcess`,
  REGISTER_CONFIRM: `/${GATE_WAY}/v1/public/account/user/registerConfirmForNewProcess`,

  //recharge
  GET_RECHARGE_CURRENT_PRODUCT: `/${GATE_WAY}/v1/public/marketing/deposit/currentProduct`,
  GET_RECHARGE_USER_INFO: `/${GATE_WAY}/v1/private/marketing/deposit/userProductInfo`,
  GET_RECHARGE_CURRENT_PROGRESS: `/${GATE_WAY}/v1/public/marketing/deposit/totalDeposit`,
  GET_RECHARGE_PRODUCT_TIER: `/${GATE_WAY}/v1/public/marketing/deposit/productTierCfg`,
  FETCH_RECHARGE_RECORD_LIST: `/${GATE_WAY}/v1/private/marketing/deposit/userDepositRecords`,
  GET_ALL_COIN_NETWORK: `/${GATE_WAY}/v1/private/capital/config/getAll`,
  FETCH_RECHARGE_ADDRESS: `/${GATE_WAY}/v1/private/capital/deposit/getAddress`,
};
